angular
  .module('affiliateUser')
  .component('affiliateUser', {
    template: require('./affiliate-user.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function AffiliateCompanyViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $rootScope.mainmenu = 'affiliate';
        $rootScope.menu = 'affiliateUser';
        $scope.showUser = $rootScope.gShowUserView;
        this.targetAffiliate = '-1';
        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        $resource(`${APIURL}/admin/affiliate`).get().$promise
          .then((data) => {
            this.affiliates = data.affiliates;
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.paging = (page) => {
          $resource(`${APIURL}/admin/affiliate/user`).get({ page: page - 1, q: this.query, targetAffiliate: this.targetAffiliate },
            (data) => {
              this.affiliateUsers = data.affiliateUsers;
              this.total_count = data.count;
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.view = (user) => {
          this.affiliateUser = user;
          jQuery('#modal-view').modal('show');
        };
        this.cancelAuthentication = (affiliateUser) => {
          if (!confirm($translate.instant('제휴 인증을 취소하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/affiliate/user/:tbAffiliateUserId/cancel`, { tbAffiliateUserId: affiliateUser.ID }).save().$promise
            .then(() => {
              this.paging(1);
              jQuery('#modal-view').modal('hide');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.delete = (affiliateUser) => {
          if (!confirm($translate.instant('제휴 회원에서 제외 하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/affiliate/user/:id`, { id: affiliateUser.ID }).delete().$promise
            .then(() => {
              this.affiliateUsers = this.affiliateUsers.filter(item => item !== affiliateUser);
              jQuery('#modal-view').modal('hide');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.confirm = (affiliateUser) => {
          if (!affiliateUser || !affiliateUser.EMAIL) {
            alert($translate.instant('알수 없는 에러 입니다.'));
            return;
          }
          $resource(`${APIURL}/users/affiliate/confirm`, { EMAIL: affiliateUser.EMAIL }).get().$promise
            .then(() => {
              this.paging(1);
              jQuery('#modal-view').modal('hide');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.showAddModal = () => {
          if (!this.affiliates || this.affiliates.length < 1) {
            alert($translate.instant('등록된 제휴사가 없어 회원을 등록 할 수 없습니다.'));
            return;
          }
          this.payloadForAdd = { targetAffiliateId: this.affiliates[0].ID.toString() };
          jQuery('#modal-add').modal('show');
        };

        this.searchUsers = () => {
          $resource(`${APIURL}/admin/users`).get({ q: this.payloadForUserSearch.query, count: -1 }, (data) => {
            this.payloadForUserSearch.result = data.users;
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };

        this.addAffiliateUser = (user) => {
          $resource(`${APIURL}/admin/affiliate/:id/tbUserId/:tbUserId`, { id: this.payloadForAdd.targetAffiliateId, tbUserId: user.ID }).save().$promise
            .then(() => {
              this.paging(1);
              jQuery('#modal-add').modal('hide');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.paging(1);
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/affiliate-user/affiliate-user.component.js